"use client";
import React, { useRef, useEffect, useState } from "react";
import RegisterForm from "@/components/RegisterForm";
import Image from "next/image";
import Link from "next/link";
import { TypewriterEffectSmooth } from "@/components/typewriter-effect";

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(" ");
}

export default function Register() {
  const words = [
    {
      text: "Exclusive Limited Collection",
    },
  ];
  return (
    <>
      <div className="w-full min-h-screen h-full  flex justify-center items-center relative bg-[url('/assets/gallery/interior/kirchen_pano02.webp')] bg-fixed bg-cover bg-center bg-no-repeat bg-black/35 bg-blend-multiply    ">
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-items-center min-h-screen   ">
          <div className="min-h-[70vh] lg:col-span-2 w-full   p-6 md:p-10 xl:p-14 flex flex-col justify-center gap-4 items-center md:items-start md:justify-between">
            <Link
              href={"/"}
              className="w-24 flex items-center justify-center relative mb-4 -mt-4"
            >
              <Image
                src="/assets/Bann-logowhite-01.svg"
                alt="logo"
                sizes="100vw"
                priority
                width={0}
                height={0}
                style={{ objectFit: "contain", objectPosition: "center" }}
                className="w-full h-full"
              />
            </Link>

            <div className="text-white flex flex-col gap-1 items-center md:items-start">
              <h1 className="text-white font-serif  text-base md:text-lg drop-shadow text-center  italic leading-snug md:text-left">
                Experience <br /> an urban living phenomenon
              </h1>
              <p className="text-white text-xl md:text-2xl uppercase font-serif text-center -mt-[2px] max-w-md font-medium drop-shadow md:text-left">
                Every corner of your new home is a sanctuary
              </p>

              <span className="w-28 h-[1px] bg-white/75 my-4 md:my-7 opacity-75"></span>

              <h1 className="text-white  text-xl font-medium uppercase my-1 drop-shadow-md  text-center md:text-left">
                Limited Units Available
              </h1>

              <p className="text-white/85 text-center md:text-left text-sm  font-light">
                To make an appointment please call{" "}
                <span className="text-white">
                  <a href="tel:+6626509899"> (02) 650 9899</a>
                </span>{" "}
              </p>
            </div>
          </div>
          <div className="w-full h-full bg-[#82603f]  to flex items-center justify-center backdrop-blur-sm">
            <RegisterForm />
          </div>
        </div>
      </div>
    </>
  );
}
